import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartLine20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconChartLine20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.302 8.241a.75.75 0 0 0-1.21.15l-3 5.5a.75.75 0 1 0 1.317.718l2.5-4.582 2.29 2.482a.75.75 0 0 0 1.264-.278l2.41-7.427 2.196 4.76a.75.75 0 0 0 1.362-.628l-3-6.5a.75.75 0 0 0-1.394.083l-2.605 8.03zM2 16.5A.75.75 0 0 0 2 18h16a.75.75 0 0 0 0-1.5z"
            />
        </svg>
    );
}
export default memo(IconChartLine20);
